(function () {
  var STORAGE_KEY = 'recentlyViewedProducts';
  var SECTION_ID = 'recently-viewed-card';

  function getHandles() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  var container = document.querySelector('[data-recently-viewed]');
  var grid = document.querySelector('[data-recently-viewed-grid]');
  if (!container || !grid) return;

  var handles = getHandles();
  if (!handles.length) return;

  // Server-rendered through sections/recently-viewed-card.liquid (which just
  // renders the shared product-card snippet) rather than the raw
  // /products/{handle}.js JSON endpoint, so each card goes through the same
  // Liquid logic as everywhere else — including the BSS B2B Lock price
  // check, which a client-side JSON fetch would bypass entirely.
  Promise.all(
    handles.slice(0, 5).map(function (handle) {
      return fetch('/products/' + handle + '?section_id=' + SECTION_ID)
        .then(function (response) {
          return response.ok ? response.text() : null;
        })
        .catch(function () {
          return null;
        });
    })
  ).then(function (renderedSections) {
    var parser = new DOMParser();
    var cards = [];

    renderedSections.filter(Boolean).forEach(function (html) {
      var doc = parser.parseFromString(html, 'text/html');
      var card = doc.querySelector('.product-card');
      if (card) cards.push(card);
    });

    if (!cards.length) return;

    cards.forEach(function (card) {
      grid.appendChild(card);
    });

    container.hidden = false;
  });
})();
